import Baremetal_Img from "public/bare-metal/bare-metal-server_reason.png";

export const REASON_COMP = {
  image: Baremetal_Img,
  title: "Why Choose OneMind Services? ",
  points: [
    {
      label: "Uncompromised Performance",
      text: "OneMind Services Bare Metal eliminates resource sharing, ensuring peak efficiency without virtualization overhead.",
    },
    {
      label: "Scalable and Flexible Infrastructure",
      text: "Built on a proven background in enterprise infrastructure, our platform ensures consistent performance for mission-critical workloads.",
    },
    {
      label: "Enterprise-Grade Security",
      text: "Single-tenant servers provide maximum data protection and compliance for industries with strict security requirements.",
    },
    {
      label: "Cutting-Edge Hardware",
      text: "Featuring the latest Intel and AMD processors, high-memory capacity, and ultra-fast NVMe storage for superior speed and reliability.",
    },
    {
      label: "Low Latency & Maximum Uptime",
      text: "A global network of data centers ensures high-speed connectivity and 99.99% uptime for mission-critical workloads.",
    },
  ],
};
